import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGS } from '../../lib/i18n'
import '../onboarding/onboarding.css'
import './settings.css'

const LANGUAGE_NAMES = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano'
}

const SettingsLanguage = () => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const current = i18n.language || 'en'
  const resolved = i18n.resolvedLanguage || current

  const onBack = () => navigate('/app/profile/settings')
  const onSelect = (lng) => {
    i18n.changeLanguage(lng)
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← {t('common.back')}</button>
        </div>
        <h1 className="h1">{t('settings.language')}</h1>
        <p className="p" style={{ marginBottom: 16, color: 'var(--gray)' }}>
          {t('settings.languageDescription')}
        </p>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {SUPPORTED_LANGS.map((lng) => (
            <li key={lng}>
              <button
                type="button"
                className="settings-list-item"
                onClick={() => onSelect(lng)}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span>{LANGUAGE_NAMES[lng] || lng}</span>
                {(resolved === lng || resolved.startsWith(lng + '-')) && (
                  <span style={{ color: 'var(--gray)', fontSize: 14 }}>✓</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SettingsLanguage
